import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as infoTableReducer, REDUCER_NAME as INFO_TABLE_REDUCER_NAME } from './overview/info-table'
import { reducer as uploadReducer, REDUCER_NAME as UPLOAD_REDUCER_NAME } from './overview/csv-upload'


const reducer = combineReducers({
    [UPLOAD_REDUCER_NAME]: uploadReducer,
    [INFO_TABLE_REDUCER_NAME]: infoTableReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/foil/state/index.js